@if (profile?.customer) {
  <li>
    <a [class]="linkClass" routerLinkActive="is-current" [routerLink]="['/shop-purchase-order-group-list']" i18n>Einkäufe</a>
  </li>
  <li>
    <a [class]="linkClass" routerLinkActive="is-current" [routerLink]="['/shop-sale-order-list']" i18n>Verkäufe</a>
  </li>
  @if (profile?.customer?.isRetailer) {
    <li>
      <a [class]="linkClass" routerLinkActive="is-current" [routerLink]="['/shop-invoice-list']" i18n>Rechnungen</a>
    </li>
  }
  @if (profile?.customer?.isRetailer) {
    <li>
      <a [class]="linkClass" routerLinkActive="is-current" [routerLink]="['/shop-order-claim-list']" i18n
        >Reklamationen</a
        >@if (pendingClaims != 0) {
        <span class="badge bg-primary">{{ pendingClaims }}</span>
      }
    </li>
  }
  @if (profile?.isCarrier && isAdmin) {
    <li>
      <a [class]="linkClass" routerLinkActive="is-current" [routerLink]="['/scan-provider-list']" i18n>Scan Provider</a>
    </li>
  }
  @if (profile?.isCarrier && isAdmin) {
    <li>
      <a [class]="linkClass" routerLinkActive="is-current" [routerLink]="['/resolution-vocabulary']" i18n>Erkennungsbegriffe</a>
    </li>
  }
  @if (profile?.isCarrier && isAdmin) {
    <li>
      <a [class]="linkClass" routerLinkActive="is-current" [routerLink]="['/reference-translations']" i18n>Übersetzungen</a>
    </li>
  }
  @if (profile?.isCarrier && isAdmin) {
    <li>
      <a [class]="linkClass" routerLinkActive="is-current" [routerLink]="['/email-queue']" i18n>E-Mail-Warteschlange</a>
    </li>
  }
  @if (profile?.isCarrier && isAdmin) {
    <li>
      <a [class]="linkClass" routerLinkActive="is-current" [routerLink]="['/shop-customer']" i18n>Kunden</a>
    </li>
  }
  @if (isAdmin) {
    <li>
      <a [class]="linkClass" routerLinkActive="is-current" [routerLink]="['/sku-list']" i18n>Artikel</a>
    </li>
  }
  @if (profile?.customer?.isRetailer && isAdmin) {
    <li>
      <a [class]="linkClass" routerLinkActive="is-current" [routerLink]="['/shop-user-list']" i18n>Benutzer</a>
    </li>
  }
  @if (profile?.isCarrier && isAdmin) {
    <li>
      <a [class]="linkClass" routerLinkActive="is-current" [routerLink]="['/shop-registration-list']" i18n>Registrierungen</a>
    </li>
  }
  @if (profile?.customer?.isRetailer && isAdmin) {
    <li>
      <a [class]="linkClass" routerLinkActive="is-current" [routerLink]="['/shop-blog-list']" i18n>Meldungen</a>
    </li>
  }
  <li>
    <a [class]="linkClass" routerLinkActive="is-current" [routerLink]="['/shop-settings']" i18n>Einstellungen</a>
  </li>
  <li>
    <a [class]="linkClass" routerLinkActive="is-current" [routerLink]="['/shop-profile']" i18n>Meine Daten</a>
  </li>
  <!-- #221: the IDP's page — a full-page navigation, never a route of this app. -->
  <li>
    <a [class]="linkClass" [href]="changePasswordUrl" data-testid="my-account-nav-change-password-link" i18n>Passwort ändern</a>
  </li>
}
